import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/contact";

export const WhatsAppFloat = () => (
  <a
    href={CONTACT.whatsappHref}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float-btn"
    className="fixed bottom-6 right-6 z-50 group flex items-center"
  >
    <span className="mr-3 hidden group-hover:block bg-[#0A1128] text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap shadow-lg animate-in fade-in duration-200">
      Have a quick question? Ask us here.
    </span>
    <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-[0_8px_24px_rgba(37,211,102,0.5)] hover:scale-110 transition-transform duration-300">
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
      <MessageCircle className="relative text-white" size={26} fill="white" strokeWidth={0} />
    </span>
  </a>
);
